import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { stages } from '../../consent-location-of-buildings-smaller-distance.routes';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import {
  ConsentLocationOfBuildingsSmallerDistanceLocalisationDataForm
} from './forms/consent-location-of-buildings-smaller-distance-localisation-data.form';
import { updateParcels } from '../../../../../../store/actions/application.actions';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import {
  ExposedMapControlComponent
} from '../../../../../../common/exposed-map/exposed-map-control/exposed-map-control.component';
import { CommonModule } from '@angular/common';
import { ParcelsCrudComponent } from '../../../common/components/parcels/parcels-crud/parcels-crud.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RoadControlsSetComponent } from '../../../common/components/road-controls-set/road-controls-set.component';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { NgxMaskDirective } from 'ngx-mask';
import { DistanceLabelPipe } from '../../../../../../pipes/distance-label.pipe';
import {
  ObjectNameOrAdvertisementDescLabelPipe
} from '../../../../../../pipes/object-name-or-advertisement-desc-label.pipe';

@Component({
  selector: 'app-consent-location-of-buildings-smaller-distance-localisation-data-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ExposedMapControlComponent,
    CommonModule,
    ParcelsCrudComponent,
    ReactiveFormsModule,
    RoadControlsSetComponent,
    ValidationErrorsComponent,
    NgxMaskDirective,
    DistanceLabelPipe,
    ObjectNameOrAdvertisementDescLabelPipe
  ],
  providers: [ConsentLocationOfBuildingsSmallerDistanceLocalisationDataForm],
  templateUrl: './consent-location-of-buildings-smaller-distance-localisation-data-section.component.html'
})
export class ConsentLocationOfBuildingsSmallerDistanceLocalisationDataSectionComponent implements OnDestroy {

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public stages: string[] = stages;

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public form: ConsentLocationOfBuildingsSmallerDistanceLocalisationDataForm = inject(ConsentLocationOfBuildingsSmallerDistanceLocalisationDataForm);

  private fetchApplication: Subscription = toObservable(this.application).subscribe((app) => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public submitAndGoNext(): void {
    const currentApp = this.application();
    if (this.form.valid && currentApp) {
      this.store$.dispatch(updateParcels({
        currentApp,
        payload: this.form.toWriteModel(),
        parcels: this.form.parcelsValues,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../inwestor'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
